import $ from 'jquery';
import executeOptionalCallback from './executeOptionalCallback';

export function smoothScrollToTarget(event, fragment = null) {
  // if this is a screenreader link, skip it
  if ($(this).hasClass('sr-only')) {
    return;
  }

  // otherwise stop the default action
  event.preventDefault();

  const target = fragment ? fragment : $(this).attr('href');

  // give other JS a chance to restore default scrolling behaviour
  requestAnimationFrame(() => {
    // then animate to the desired section
    $('html, body').animate({
      scrollTop: $(`#${target}`).offset().top - $('.kg-header__wrapper').height()
    });
  });
}

export function scrollToTarget(target, parent = document.querySelector('body'), options = {}) {
  if (!target) {
    return;
  }

  const {top, bottom} = target.getBoundingClientRect();

  // Defaults
  options = Object.assign({
    alwaysScroll: false,
    ignorePadding: false,
    duration: 400,
    easing: 'swing',
    offset: 0,
  }, options || {});

  // Don't scroll if no need to
  if (top >= 20 && bottom <= parent.innerHeight + 20 && !options.alwaysScroll) {
    return;
  }

  const settings = {
    duration: options.duration,
    easing: options.easing,
    offset: options.offset,
  };

  const y = options.ignorePadding ?
    top + parent.scrollY + settings.offset + parseInt(parent.getComputedStyle(target).paddingTop.replace('px', '') || '0') :
    $(target).offset().top + settings.offset;

  $(parent).scrollTop(0);
  $(parent).animate({
    scrollTop: y,
  }, settings.duration, settings.easing, () => executeOptionalCallback(options.callback));
}

/**
 * @typedef {Object} ScrollTo
 * @property {string} [axis="xy"] - The axis to scroll on, valid values: "xy", "x", or "y"
 * @property {boolean} [interrupt=false] - If true will cancel the animation if the user scrolls
 * @property {Object|Number} [offset=0] - Offset added to final position, can be a number or object with left and top
 * @property {boolean} [margin=false] - If true. subtracts the margin, padding, border of the target element
 * @property {Number} [duration=400] - Duration of the animation
 * @property {String} [easing="swing"] - Name of easing equation
 */
/**
 * TODO: If this is to be used more, it should be built out more thoroughly.
 *
 * @param {HTMLElement|string} target - The HTMLElement or selector of the element to scroll to within element
 * @param {HTMLElement|string} [parent="window"] - The HTMLElement or selector of the element to scroll
 * @param {ScrollTo} options - @see ScrollTo
 * @returns {undefined}
 */
export function scrollTo(target, parent = document.querySelector('body'), options = {}) {
  const defaults = {
    axis: 'xy',
    interrupt: false,
    offset: 0,
    duration: 400,
    easing: 'swing',
  };

  options = Object.assign(defaults, options);

  let container, element, settings = {};

  // Break right away if there's no element to scroll to
  if (target === null) {
    return;
  }

  container = typeof parent === 'string' ? document.querySelector(parent) : parent;
  element = typeof target === 'string' ? document.querySelector(target) : target;

  const $container = $(container);

  // Real position of target
  const targetPos = element.getBoundingClientRect();
  const parentOffset = $container.offset();

  options.axis.split().forEach(axis => {
    // If scrollable
    if (axis === 'x' && isScrolling(container, true) || axis === 'y' && isScrolling(container, false)) {
      const Pos = axis === 'x' ? 'Left' : 'Top',
        pos = Pos.toLowerCase(),
        setting = 'scroll' + Pos;

      if (targetPos) {
        settings[setting] = targetPos[pos] - parentOffset[pos] - parseInt($container.css('padding' + Pos));
      }

      $container.animate(settings, {
        duration: options.duration,
        easing: options.easing,
      });
    }
  });
}

/**
  * Has scrolling happened in an element?
  *
  * @param {HTMLElement} element - The HTMLelement to check if it's scrolling
  * @param {boolean} isHorizontal - If true, checks scrolling on the x access; otherwise checks the y axis
  * @return {boolean} True if the element is scrolling, false otherwise
  */
const isScrolling = (element, isHorizontal = false) => {
  let isScrolling = false;

  if (element) {
    isScrolling = isHorizontal ? element.scrollWidth > element.clientWidth : element.scrollHeight > element.clientHeight;
  }

  return isScrolling;
};
